import { useCallback, useState } from 'react';

import useToast from 'components/ToastProvider/useToast';
import { logEvent } from 'features/Analytics/analytics';
import { useUser } from 'helpers/auth';
import { post } from 'helpers/fetch';

import locales from './locales';

interface UseSendDownloadSmsReturnType {
  usedPhone?: string;
  isSending: boolean;
  sendDownloadSMS: (phoneNumber?: string) => Promise<void>;
}

const useSendDownloadSMS = (
  analyticsLoggedEvent: string,
): UseSendDownloadSmsReturnType => {
  const { hideToast, showToast } = useToast();
  const [isSending, setIsSending] = useState(false);
  const user = useUser();
  const { phone: usedPhone } = user;

  const sendDownloadSMS = useCallback(
    async (phoneNumber?: string) => {
      logEvent({ name: analyticsLoggedEvent });
      hideToast();
      setIsSending(true);
      return post('/api/download', {
        phone: phoneNumber || usedPhone,
      })
        .then(() => {
          setIsSending(false);
          showToast({
            message: locales.downloadSucceed,
            type: 'success',
          });
        })
        .catch((error): void => {
          setIsSending(false);
          showToast({
            message: locales.downloadFail,
            type: 'error',
          });
          // Rethrow so that the user of sendDownloadSMS does not continue
          // with its success action.
          throw error;
        });
    },
    [analyticsLoggedEvent, hideToast, showToast, usedPhone],
  );

  return { isSending, sendDownloadSMS, usedPhone };
};

export default useSendDownloadSMS;
